import React from 'react'
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import cssClasses from './Units.module.css'
import MyTimer from './Timer';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Popover, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { cloneDeep } from 'lodash';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary
}));

export default function Units({ unit, style, changeUnitStatus, showCheckbox, setUnitsToMerge, unitsToMerge, merge = false, paired = false, pairedInfo = '', farvisionStatus, showPrice }) {
    const UNIT_COLOR_SCHEMA = {
        "Available": {
            color: "#027A48",
            background: "#D1FADF"
        },
        "On Hold": {
            color: "#B54708",
            background: "#FEF0C7"
        },
        "Payment Pending": {
            color: "#B42318",
            background: "#FEE4E2"
        },
        "Reserved": {
            color: "#6941C6",
            background: "#F4EBFF"
        },
        "Locked": {
            color: "#344054",
            background: "#F2F4F7"
        },
        "Preselected": {
            color: "red",
            background: "#F2F4F7"
        },
        "Kyc Pending": {
            color: "#0E7090",
            background: "#ECFDFF"
            // color: "rgb(89, 37, 220)",
            // background: "rgb(244, 243, 255)"
        },
        "Alloted": {
            color: "rgb(89, 37, 220)",
            background: "rgb(244, 243, 255)"
        },
        "Kyc Done": {
            color: "#2E90FA",
            background: "#D1E9FF"
        },
    }
    const FV_COLOR_SCHEMA = {
        "Available": {
            color: "#027A48",
            background: "#D1FADF"
        },
        "Booked": {
            color: '#B42318',
            backgroundColor: '#FEE4E2'
        },
        "Blocked": {
            color: '#6941C6',
            backgroundColor: '#F4EBFF'
        },
        "Hold": {
            color: "#B54708",
            background: "#FEF0C7"
        },
    }
    const [anchorEl, setAnchorEl] = React.useState(null);
    // console.log(process.env)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <Grid item xs={1} sm={1} md={1} lg={1}>
            <Item style={{ background: UNIT_COLOR_SCHEMA[unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status].background, boxShadow: "unset", borderRadius: "0.5rem", padding: "1rem", border: "1px solid #D0D5DD" }}>
                <div class={cssClasses.mainDiv}>
                    {showCheckbox() && (unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status) === 'Available' &&
                        < div >
                            <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={changeUnitStatus} checked={merge ? unit.isSelectedForMerge : unit.isSelected} />
                                <span class={cssClasses.checkmark}></span>
                            </label>
                        </div>
                    }
                    {paired && merge &&
                        <DeleteIcon style={{
                            width: '2rem',
                            height: '2rem'
                        }}
                            onClick={() => {
                                let arr = cloneDeep(unitsToMerge)
                                arr.splice(arr.findIndex((e) => e.unit1Id === unit.unitId || e.unit2Id === unit.unitId), 1)
                                // console.log(arr.findIndex((e) => e.unit1Id === unit.unitId || e.unit2Id === unit.unitId))
                                console.log(arr)
                                setUnitsToMerge(arr)
                            }}
                        />
                    }
                </div>
                <div style={{ padding: paired ? "0.3rem 1.1rem" : "2.6rem 1rem 1.9rem 1rem", margin: !merge && paired ? "0.75rem 0" : 'unset' }} className={cssClasses.textDiv}>
                    {unit.timer > Date.now() &&
                        <MyTimer css={UNIT_COLOR_SCHEMA[unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status].color} expiryTimestamp={unit.timer} />
                    }
                    <p style={{
                        color: UNIT_COLOR_SCHEMA[unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status].color
                    }}>{unit?.inventoryTypeId?.type ? unit?.inventoryTypeId?.type : unit.type}</p>
                    {unit?.displayUnitType &&
                        < p style={{
                            color: UNIT_COLOR_SCHEMA[unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status].color
                        }}>({unit?.displayUnitType})</p>
                    }
                    <p style={{
                        color: UNIT_COLOR_SCHEMA[unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status].color,
                    }}>{unit.unitNo}</p>
                     <p style={{
                        color: UNIT_COLOR_SCHEMA[unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status].color,
                    }}>{unit.unitOf}</p>
                    {paired &&
                        <p style={{
                            color: UNIT_COLOR_SCHEMA[unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status].color,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem'
                        }}>
                            <span>Paired</span>
                            <div style={{ display: "flex" }}>
                                <InfoOutlinedIcon onClick={handleClick} style={{ width: "2rem", height: "2rem", color: "#344054" }}></InfoOutlinedIcon>
                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                >
                                    <Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>{pairedInfo()}</Typography>
                                </Popover>
                            </div>
                        </p>
                    }
                    <p style={{
                        color: UNIT_COLOR_SCHEMA[unit?.inventoryStatusId?.status ? unit?.inventoryStatusId?.status : unit.status].color
                    }}>{unit?.cost}</p>
                    {farvisionStatus &&
                        <p style={{
                            color: FV_COLOR_SCHEMA[unit?.farvisionStatus]?.color, fontSize: '1.2rem'
                        }}>FV Status: {unit?.farvisionStatus}</p>
                    }
                </div>
            </Item>
        </Grid >
    );
}
